// extracted by mini-css-extract-plugin
export default {"gallery":"gallery_gallery__4qlx1","item":"gallery_item__3yS4p"};